import React, { FC, ReactNode, useRef } from 'react'
import classNames from 'classnames'
import _Switch from 'rc-switch'

type SwitchProps = {
  label?: ReactNode
  className?: string
  disabled?: boolean
  checked: boolean
  onChange: (newValue: boolean) => void
  id?: string
}

const Switch: FC<SwitchProps> = ({
  checked,
  className,
  id,
  label,
  onChange,
  ...rest
}) => {
  const ref = useRef<HTMLInputElement>()
  return (
    <div
      className={classNames('lh-input d-flex align-items-center', className)}
    >
      <_Switch
        {...rest}
        id={id}
        checked={checked}
        onChange={(e) => {
          ref.current?.blur()
          onChange(e)
        }}
      />
      <label
        onClick={() => {
          ref.current?.blur()
          onChange(!checked)
        }}
        className={classNames(
          'ms-2 cursor-pointer fw-semibold user-select-none form-check-label',
          {
            disabled: rest.disabled,
          },
        )}
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  )
}

Switch.displayName = 'Switch'

export default Switch
